// Vendor imports
const React = require('react')

function useSymbol(description) {
  const ref = React.useRef()
  if (!ref.current) {
    ref.current = Symbol(description)
  }
  return ref.current
}

module.exports = useSymbol
